import posthog from 'posthog-js'

// Top-level path segments that are NOT product pages
const NON_PRODUCT_PATHS = new Set([
  '',
  'about',
  'admin',
  'api',
  'auth',
  'authenticating',
  'black-friday',
  'Black-Friday-2025',
  'blog',
  'brands',
  'buyer-guide',
  'category',
  'christmas',
  'collections',
  'condition-guide',
  'cookie-policy',
  'country',
  'curation',
  'dashboard',
  'data-privacy',
  'help',
  'highlights',
  'how-it-works',
  'imprint',
  'investor',
  'jobs',
  'maintenance',
  'payment',
  'portfolio-guide',
  'press',
  'region',
  'review',
  'search',
  'selection',
  'sell',
  'seller',
  'seller-guide',
  'shipping-guide',
  'sign_up_fb_ad',
  'sitemaps',
  'sitemap.txt',
  'sku',
  'special_offer',
  'terms',
  'buying_limited_offer',
  'selling_limited_offer',
])

function getPageType(url: string): string {
  try {
    const pathname = new URL(url).pathname
    const firstSegment = pathname.split('/').filter(Boolean)[0] ?? ''
    return NON_PRODUCT_PATHS.has(firstSegment) ? 'other' : 'product'
  } catch {
    return 'other'
  }
}

// Initialize PostHog on the client. Next.js 15.3+ will automatically pick up this file.
posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  // Apply recommended defaults for new projects (per PostHog docs)
  defaults: '2026-01-30',
  before_send: (event) => {
    if (event?.event === '$pageview' && event.properties?.$current_url) {
      event.properties.page_type = getPageType(event.properties.$current_url)
    }
    return event
  },
})

export default posthog
